import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpBaseService } from '../../service/http-base.service';
import { ResponseResult } from '../../models/authentication/login';
import { HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import { domain } from 'process';
import { AuthTokenHelper } from '@helpers/auth-token-helper';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  returnUrl: string;
  showValidation: boolean = false;
  public apiURL = null;
  domain:string;
  user:string;
  userName:string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private httpService: HttpBaseService,
    private authHelper?: AuthTokenHelper
  ) {}
  ngOnInit() {
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}auth/ForgotPassword`;
    });

    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
    });
    this.spinner.hide();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }
  get f() {
    return this.loginForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    } else {
      this.userName =  this.loginForm.getRawValue().username;
      [this.user, this.domain] = this.userName.split('@');
      const data = new HttpHeaders()
        .set('username', this.userName)
        .set('Token', this.authHelper.GetAuthorizationTokenValue())
        .set('domain',this.domain)
      this.httpService.postWithHeader(`${this.apiURL}`, null, data).subscribe(response => {       
        var result = response as ResponseResult;
        
        if (result) {
          this.showValidation = true;
        }
        else {
          this.showValidation = false;
        }
      }, error => {
        
        if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
          this.showValidation = false;
          if (this.loginForm) {
            this.loginForm.controls['username'].setErrors({ 'incorrect': true });           
          }
          return false;
        }
          this.showValidation = false;
      });
    }
  }
}
